import { Controller } from "@hotwired/stimulus"
import { suppressProgressBar } from "../lib/helpers"

export default class extends Controller {
  static targets = ["circle"]
  static values = { enabled: Boolean }

  slide(event) {
    if (this.element.dataset.sliding) return
    this.element.dataset.sliding = true
    event.preventDefault()

    const circle = this.circleTarget

    if (this.enabledValue) {
      circle.classList.remove("left-5.5", "bg-emerald-400")
      circle.classList.add("left-[5px]", "bg-amber-400")
    } else {
      circle.classList.remove("left-[5px]", "bg-gray-400", "dark:bg-gray-500")
      circle.classList.add("left-5.5", "bg-amber-400")
    }

    setTimeout(() => {
      suppressProgressBar()
      this.element.requestSubmit()
    }, 200)
  }
}
